import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "topic",
  components: {
    draggable: draggable
  },
  props: ["childModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      subjectData: {},
      span: 1,
      col: 4,
      changed: false
    };
  },
  created: function created() {
    var subject = this.moduleList.find(function (item) {
      return item.cardType === "TOPIC";
    });

    if (subject) {
      this.subjectData = JSON.parse(JSON.stringify(subject.cardModules[0]));
      this.col = subject.cardModules[0].col;
    }
  },
  computed: _objectSpread({}, mapGetters(["moduleList"])),
  methods: {
    changeLayout: function changeLayout() {
      // if(this.col * this.span < this.subjectData.data.length){
      //   this.subjectData.data.length = this.col * this.span
      // }
      this.$emit("caseChanged", true);
    },
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    addModuleItem: function addModuleItem(e) {
      // // 判断是否超出个数限制
      // const limit = this.span * this.col;
      // if(this.subjectData.data.length >= limit){
      //   this.$message.warning('超出设置的行数,若要继续添加请修改行列数')
      //   return
      // }
      var targetIndex = e.newIndex;
      var childModulesIndex = e.oldIndex;
      var childModule = this.childModules[childModulesIndex]; // 判断添加的模块是否存在

      var exist;

      if (this.subjectData.data) {
        exist = this.subjectData.data.some(function (item) {
          return item.topicId === childModule.topicId;
        });
      } else {
        this.subjectData.data = [];
        exist = false;
      }

      if (exist) {
        this.$message.warning("不能重复添加已添加的模块");
        return;
      }

      this.subjectData.data.splice(targetIndex, 0, childModule);
      this.$emit("caseChanged", true);
    },
    sortModuleItem: function sortModuleItem(e) {
      var newIndex = e.newIndex;
      var oldIndex = e.oldIndex;
      var moduleItem = this.subjectData.data[oldIndex];
      this.subjectData.data.splice(oldIndex, 1);
      this.subjectData.data.splice(newIndex, 0, moduleItem);
      this.$emit("caseChanged", true);
    },
    removeModules: function removeModules(item, index) {
      this.subjectData.data.splice(index, 1);
      this.$emit("caseChanged", true);
    },
    isEmpty: function isEmpty() {
      return this.subjectData.data.length ? false : true;
    }
  },
  watch: {
    "subjectData.data": function subjectDataData(val) {
      this.$emit("selectedChange", {
        data: val,
        module: "topic",
        col: this.col
      });
    },
    col: function col(val) {
      this.$emit("selectedChange", {
        data: this.subjectData.data,
        module: "topic",
        col: this.col
      });
    }
  },
  filters: {}
};